
import './App.css';
import { Routes, Route} from "react-router-dom";
import Home from "./screen/Home";
 import Register from "./screen/Register";
 import Login from "./screen/Login";
import './screen/Login.css';
import React from "react";
import AddUser from './screen/AddUser';
import Forgot from './screen/ForgotPassword';
function App() {
  return (
      <div className='App'>
        <Routes>
        <Route path="/"  element={<Login/>}/>
         <Route path="/Home"  element={<Home/>}/>
          <Route path="/Register" element={<Register/>}/>
          <Route path="/Dashboard" element={<AddUser/>}/>
          <Route path="/ForgotPassword" element={<Forgot/>}/>
        </Routes>
      </div>
  )
  }

export default App;
